
import * as React from 'react';
import EditorProps from '../../components/editorinterface';
import { FormControl } from 'react-bootstrap';

interface Props extends EditorProps {

};

class TextEditor extends React.Component<Props> {

	constructor(props: Props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }

	public render() {
		var props = this.props;
		return (
			<FormControl
				type="text"
				value={props.value===null || props.value===undefined ? "" : props.value}
				placeholder="Enter text"
				onChange={this.onChange}
				readOnly={!!props.field.readOnly}
			/>
		);
	}

	private onChange(e: any) {
		const value = e.target.value;
		this.props.onChange(this.props.field.id,value);
	}
}


export default TextEditor;



// WEBPACK FOOTER //
// ./src/components/texteditor/index.tsx